import axios from 'axios';
import get from 'lodash/get';
import moment from 'moment';
import queryString from 'query-string';
import Constants from '../Constants';

const BASE_INVOICE_URL = `${Constants.URL}invoices`;
const FETCH_US_INVOICE_POS_URL = `${Constants.URL}invoices/packer-invoice-orders-us`;
const GENERATE_US_INVOICE_REPORT = `${Constants.URL}invoices/packer-invoice-orders-us`;
const FETCH_US_INVOICE_HISTORICAL_URL = `${Constants.URL}invoices/us-packer-invoiced-drawdowns`;

export const REQUEST_US_INVOICE_POS = 'REQUEST_US_INVOICE_POS';
export const US_INVOICE_POS = 'US_INVOICE_POS';
export const US_INVOICE_LINK = 'US_INVOICE_LINK';
export const US_INVOICE_HISTORICAL = 'US_INVOICE_HISTORICAL';
export const ERROR_GET_US_INVOICE_POS = 'ERROR_GET_US_INVOICE_POS';

const createAuthHeaders = token => ({
  'Content-Type': 'application/json',
  Authorization: `Token ${token}`,
});

/* ----------------------------------
  ACTIONS
-------------------------------------*/
export function requestUSInvoicePos() {
  return {
    type: REQUEST_US_INVOICE_POS,
  };
}

export function getUSInvoicePos(usInvoiceOrders) {
  return {
    type: US_INVOICE_POS,
    usInvoiceOrders,
  };
}

export function downloadUSInvoiceReport(generatedUSInvoiceLink) {
  return {
    type: US_INVOICE_LINK,
    generatedUSInvoiceLink,
  };
}

export function getUSInvoicedPos(usInvoiceHistoricalData, pagination, pageCount) {
  return {
    type: US_INVOICE_HISTORICAL,
    usInvoiceHistoricalData,
    pagination,
    pageCount,
  };
}

export function errorGetUSInvoicePos(error) {
  return {
    type: ERROR_GET_US_INVOICE_POS,
    error,
  };
}

/* ----------------------------------
  THUNKS
-------------------------------------*/
export function fetchUSInvoicePurchaseOrders(
  token,
  { grinderReceivedStartDate, grinderReceivedEndDate, invoicingOffice }
) {
  const queryObject = {
    invoicingOffice,
  };
  
  if (moment(grinderReceivedStartDate, 'YYYY-MM-DD', true).isValid()) {
    queryObject.grinderReceivedStartDate = grinderReceivedStartDate;
  }
  if (moment(grinderReceivedEndDate, 'YYYY-MM-DD', true).isValid()) {
    queryObject.grinderReceivedEndDate = grinderReceivedEndDate;
  }
  
  const queryFilters = queryString.stringify(queryObject);
  
  return async dispatch => {
    const headers = createAuthHeaders(token);
    try {
      dispatch(requestUSInvoicePos());
      const response = await axios.get(`${FETCH_US_INVOICE_POS_URL}?${queryFilters}`, { headers });
      Constants.handleErrors(response, dispatch, errorGetUSInvoicePos);
      const usInvoiceOrders = get(response, 'data', []);
      dispatch(getUSInvoicePos(usInvoiceOrders));
    } catch (e) {
      dispatch(errorGetUSInvoicePos(e));
    }
  };
}

export function createUSInvoiceReports(token, { grinderPOs, filters, fmgPOs }) {
  return async dispatch => {
    const headers = createAuthHeaders(token);
    const clientLocalDateTime = moment().format('MM-DD-YYYY - hh.mm.ss A');
    try {
      const response = await axios.post(
        `${GENERATE_US_INVOICE_REPORT}`,
        { grinderPOs, filters, clientLocalDateTime, fmgPOs },
        { headers }
      );
      Constants.handleErrors(response, dispatch, errorGetUSInvoicePos);
      const generatedUSInvoiceLink = get(response, 'data.downloadableURL', '');
      dispatch(downloadUSInvoiceReport(generatedUSInvoiceLink));
    } catch (e) {
      dispatch(errorGetUSInvoicePos(e));
    }
  };
}

export function fetchUSInvoicedPurchaseOrders(token, { pageNum }) {
  return async dispatch => {
    const headers = createAuthHeaders(token);
    try {
      const response = await axios.get(`${FETCH_US_INVOICE_HISTORICAL_URL}?pageNum=${pageNum}`, { headers });
      Constants.handleErrors(response, dispatch, errorGetUSInvoicePos);
      const usInvoicedOrders = get(response, 'data', []);
      dispatch(
        getUSInvoicedPos(
          usInvoicedOrders.draw_down_historical_data,
          usInvoicedOrders.pagination,
          usInvoicedOrders.count
        )
      );
    } catch (e) {
      dispatch(errorGetUSInvoicePos(e));
    }
  };
}